var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from "./..";

const parseMarkdownMarker = (line, regexp, wrapper) => {
  const matches = line.match(regexp);
  if (matches == null) {
    return matches;
  }
  const parts = matches.input.split(matches[0]);
  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    parts[0],
    wrapper(matches[1]),
    parts[1]
    ));

};

const parseMarkdownBoldMarker = (line) =>
parseMarkdownMarker(line, /\*{2}(.*)\*{2}/, (text) => /*#__PURE__*/_jsx("strong", {}, void 0, text));

const parseMarkdownItalicMarker = (line) =>
parseMarkdownMarker(line, /\*(.*)\*/, (text) => /*#__PURE__*/_jsx("i", {}, void 0, text));

class Translate extends Component {
  static resetCachedTranslation() {
    Translate.translation = null;
  }

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.i18nmode) {
      e.stopPropagation();
      e.preventDefault();
      this.props.edit(this.props.context, this.props.translationKey);
    }
  }

  render() {
    const lines = this.props.children ? this.props.children.split('\n') : [];
    const className = this.props.i18nmode ? 'translation active' : 'translation';
    return /*#__PURE__*/(
      _jsx("span", { onClick: this.onClick, className: `${className} ${this.props.className}`.trim() }, void 0,
      lines.map((line, index) => {
        const boldMatches = parseMarkdownBoldMarker(line);
        const italicMatches = parseMarkdownItalicMarker(line);
        return /*#__PURE__*/(
          _jsx(Fragment, {}, `${line}-${index.toString()}`,
          boldMatches ||
          italicMatches || /*#__PURE__*/ // eslint-disable-next-line react/jsx-no-useless-fragment
          React.createElement(React.Fragment, null, line),

          index < lines.length - 1 && /*#__PURE__*/_jsx("br", {})
          ));

      })
      ));

  }
}

Translate.defaultProps = {
  i18nmode: false,
  context: 'System',
  edit: false,
  translationKey: '',
  className: ''
};










const mapStateToProps = (state, props) => {
  if (
  !Translate.translation ||
  Translate.translation.locale !== state.locale ||
  state.inlineEdit.get('inlineEdit'))
  {
    const translations = state.translations.toJS();
    Translate.translation = translations.find((t) => t.locale === state.locale) || { contexts: [] };
  }
  const _ctx = props.context || 'System';
  const key = props.translationKey || props.children;
  const context = Translate.translation.contexts.find((ctx) => ctx.id === _ctx) || { values: {} };
  const canEditThisValue = _ctx === 'System' || !!context.values[props.children];
  return {
    translationKey: key,
    children: context.values[key] || props.children,
    i18nmode: state.inlineEdit.get('inlineEdit') && canEditThisValue
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ edit: actions.inlineEditTranslation }, dispatch);
}

export { mapStateToProps, Translate };
export default connect(mapStateToProps, mapDispatchToProps)(Translate);